import React, { useRef, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import SettingsIcon from '../../assets/profile.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import ExtensionIcon from '../../assets/auto-apply.svg';
import InboxIcon from '../../assets/mainbox.svg';
import ArrowLeft from '../../assets/arrow-left.svg';
import DashboardIcon from '../../assets/dash.svg';
import MatchedIcon from '../../assets/tracker.svg';
import TrackerIcon from '../../assets/board.svg';
import Button from './Button';
import Logo from '../Logo';
import UserInfo from './UserInfo';

const Navigation = () => {
  const { isCollapsed, setIsCollapsed, autoApplyData, inboxMessages } = useApp();
  const clientId = localStorage.getItem('clientId');
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);

  const unreadCount = inboxMessages?.some((message) => message.unread);
  const ActionsRequiredCount = autoApplyData?.some(
    (application) => application.formSession.actionRequired === 'failed'
  );

  const isActive = (path) => {
    return location.pathname === path;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!isCollapsed && navRef.current && !navRef.current.contains(event.target)) {
        setIsCollapsed(true);
      }
    };
    if (!isCollapsed) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isCollapsed, setIsCollapsed]);

  const handleButtonClick = (path) => {
    navigate(path);
    setIsCollapsed(true);
  };

  return (
    <div
      inert={isCollapsed}
      className={`fixed inset-0 z-50 bg-black/20 backdrop-blur-sm transition-opacity duration-300 ease-in-out ${
        isCollapsed ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <nav
        id="navigation-wrapper"
        ref={navRef}
        className={`fixed top-0 left-0 md:w-[25%] w-[85%] h-screen bg-white backdrop-blur-sm border-r border-gray-200 transition-transform duration-300 ease-in-out ${
          isCollapsed ? '-translate-x-full' : 'translate-x-0'
        }`}
      >
        <section className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <Logo />
          </div>
          <button aria-label="Close navigation" onClick={() => setIsCollapsed(true)} style={{ width: '16px', height: '16px' }}>
            <img src={ArrowLeft} alt="" />
          </button>
        </section>
        <section className="p-4 space-y-2">
          <Button
            icon={DashboardIcon}
            text="Dashboard"
            handleClick={() => handleButtonClick('/dashboard')}
            isActive={isActive('/dashboard')}
          />
          <Button
            icon={MatchedIcon}
            text="Matched Jobs"
            handleClick={() => handleButtonClick('/matched-jobs')}
            isActive={isActive('/matched-jobs')}
          />
          <Button
            icon={TrackerIcon}
            text="Saved Jobs"
            handleClick={() => handleButtonClick('/saved-jobs')}
            isActive={isActive('/saved-jobs')}
          />
          <Button
            icon={ExtensionIcon}
            text="Auto-apply"
            handleClick={() => handleButtonClick('/auto-apply')}
            isActive={isActive('/auto-apply')}
            actionsRequired={ActionsRequiredCount}
          />
          <Button
            icon={InboxIcon}
            text="Inbox"
            handleClick={() => handleButtonClick('/inbox')}
            isActive={isActive('/inbox')}
            iconOffset={true}
            actionsRequired={unreadCount}
          />
          {/* "Documents" removed: the /documents route is disabled in App.jsx, so it led to a 404 */}
          <Button
            icon={SettingsIcon}
            text="Profile"
            handleClick={() => handleButtonClick('/profile')}
            isActive={isActive('/profile')}
          />
        </section>

        <UserInfo />
      </nav>
    </div>
  );
};

export default Navigation;
